<template>
    <div class="other-tenant-item-content other-tenant-abnormal-warn">
        <span class="other-tenant-title">接口调用异常预警</span>
        <div @mouseenter="hoverTable" @mouseleave="leaveTable">
            <el-table
            ref="elTable"
            :data="tableData"
            height="200"
            class="interface-call-table"
            header-cell-class-name="abnormal-table-header"
            @cell-dblclick="openDetail"
            @filter-change="filterChange">
                <el-table-column prop="apiName" label="接口名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column
                prop="excType"
                label="异常类型"
                width="100"
                :filters="filterList"
                :filter-method="filterTag"
                filter-placement="bottom-end"></el-table-column>
                <el-table-column prop="excDesc" label="异常描述"></el-table-column>
                <el-table-column prop="excCount" label="异常频次" width="100"></el-table-column>
            </el-table>
        </div>
        <el-dialog
            width="1200px"
            title="接口调用异常预警"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false">
            <detailTable
            :pageTotal="pageTotal"
            :config="detailConfig"
            :tableData="detailTableData"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
                <div slot="page-module-btn">
                    <el-button type="primary" @click="exportDetail" :loading="detailLoading">导出</el-button>
                </div>
            </detailTable>
        </el-dialog>
    </div>
</template>
<script>
import { getAbnormalDetailApi } from '../../../../../api/afterLoginIndex';
import { exportType } from '../../../../../api/logManagement';
import detailTable from '../../../../../components/IdentityComponent/Main';
import detailConfig from './abnormalWarnConfig';
const DETAIL_EXPORT_URL = '/api-sn/tenantIndex/getExceptionDetailStatistics/export';
const DETAIL_EXPORT_FILE_NAME = '接口调用异常预警明细.xls';
export default {
    components: { detailTable },
    data() {
        return {
            tableData: [],
            detailConfig: detailConfig,
            detailTableData: [],
            timerDataScroll: null,
            autoMillisecond: 100,
            dialogVisible: false,
            detailLoading: false,
            time: '',
            tenantCode: '',
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            detailRow: {}
        };
    },
    computed: {
        filterList() {
            const map = new Map();
            const datas = this.tableData.filter((item) => !map.has(item.excType) && map.set(item.excType, 1));
            return datas.map(item => {
                return {
                    text: item.excType,
                    value: item.excType
                };
            });
        }
    },
    methods: {
        dataProcess(data) {
            this.clearTimeData();
            this.tableData = this.formatData(data.data);
            this.time = data.time;
            this.tenantCode = data.tenantCode;
            this.$nextTick(() => {
                this.dom = this.$refs.elTable.bodyWrapper;
                this.dom.scrollTop = 0;
                this.dataScroll(this.dom, this.autoMillisecond);
            });
        },
        formatData(data) {
            const tableData = data || [];
            tableData.forEach(item => {
                (item.excCount) && (item.excCount = (item.excCount).toLocaleString());
            });
            return tableData;
        },
        clearTimeData() {
            if (this.timerDataScroll) {
                window.clearTimeout(this.timerDataScroll);
                this.timerDataScroll = null;
            }
        },
        dataScroll(dom, millisecond) {
            if (dom.scrollTop + dom.clientHeight >= dom.scrollHeight) {
                dom.scrollTop = 0;
            }
            dom.scrollTop += 1;
            this.timerDataScroll = window.setTimeout(() => {
                this.dataScroll(dom, millisecond);
            }, millisecond);
        },
        hoverTable() {
            this.clearTimeData();
        },
        leaveTable() {
            this.$nextTick(() => {
                this.dom = this.$refs.elTable.bodyWrapper;
                this.dataScroll(this.dom, this.autoMillisecond);
            });
        },
        exportDetail() {
            this.detailLoading = true;
            const params = this.getSearchParam();
            const url = DETAIL_EXPORT_URL;
            const fileName = DETAIL_EXPORT_FILE_NAME;
            exportType(params, url, 'post', fileName, () => { this.detailLoading = false; });
        },
        getSearchParam () {
            const params = {
                apiName: this.detailRow.apiName,
                excType: this.detailRow.excType,
                tenantCode: this.tenantCode,
                startTime: this.time + ' 00:00:00',
                endTime: this.time + ' 23:59:59',
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            return params;
        },
        getDetailTable() {
            const params = this.getSearchParam();
            getAbnormalDetailApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.detailTableData = res.data.list || [];
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.getDetailTable();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.getDetailTable();
        },
        openDetail(row) {
            this.detailRow = row;
            this.pageNo = 1;
            this.pageSize = 10;
            this.getDetailTable();
            this.dialogVisible = true;
        },
        filterTag(value, row) {
            this.dom.scrollTop = 0;
            return row.excType === value;
        },
        filterChange() {
            this.clearTimeData();
            this.$nextTick(() => {
                this.dom = this.$refs.elTable.bodyWrapper;
                this.dom.scrollTop = 0;
                this.dataScroll(this.dom, this.autoMillisecond);
            });
        }
    },
    beforeDestroy() {
        if (this.timerDataScroll) {
            window.clearTimeout(this.timerDataScroll);
            this.timerDataScroll = null;
        }
    }
};
</script>
<style lang="less">
.other-tenant-abnormal-warn{
    .nPanel .el-table{
        height: 376px!important;
    }
    .abnormal-table-header{
        background: #f0f1f6;
        color: #333333;
        .el-icon-arrow-down{
            font-size: 14px;
            color: #666666;
        }
    }
    .has-gutter{
        th{
            background: #f0f1f6;
        }
    }
    .abnormal-warn-list{
        padding: 16px 0 0 16px;
        li{
            font-family: 'PingFangSC-Regular', sans-serif;
            font-size: 12px;
            line-height: 40px;
            color: #333333;
            font-weight: 400;
        }
    }
}
</style>
